export default __webpack_public_path__ + "static/media/sudexlogo.97a7d48c.png";